import Axios from "./Axios";
import * as API from "./URLS";

export const LOGIN_USER = (data) => Axios.post(API.LOGIN_USER, data);
export const VERIFY_OTP = (data) => Axios.post(API.VERIFY_OTP, data);
export const CREATE_PASS_SUBADMIN = (data) =>
  Axios.post(API.CREATE_PASS_SUBADMIN, data);
export const ADMIN_DETAIL = (data) => Axios.get(API.ADMIN_DETAIL + data);
export const ROW_SORTING = (data) => Axios.post(API.ROW_SORTING, data);
export const SELECT_OTP_OPTION = (data) =>
  Axios.post(API.SELECT_OTP_OPTION, data);

//DASHOBARD

export const DASHBOARD_DETAILS = (data) =>
  Axios.post(API.DASHBOARD_DETAILS, data);

// // ================= MANAGE_CUSTOMERS =================== // //

export const CUSTOMERS_LIST = (data) => Axios.post(API.CUSTOMERS_LIST, data);
export const EDIT_MANAGE_CUSTOMER = (data) =>
  Axios.get(API.EDIT_MANAGE_CUSTOMER + data);
export const UPDATE_USER = (data) =>
  Axios.put(API.UPDATE_USER + data.userId, data);
export const ADD_USER = (data) => Axios.post(API.ADD_USER, data);
export const BLOCK_UNBLOCK_USER = (data) =>
  Axios.put(API.BLOCK_UNBLOCK_USER + data.userId, { status: data.status });
export const DELETE_USER = (data) => Axios.delete(API.DELETE_USER + data.id);
export const EXPORT_USER = (data) => Axios.post(API.EXPORT_USER, data);
export const SEND_EMAIL = (data) => Axios.post(API.SEND_EMAIL, data);
export const SEND_TEXT = (data) => Axios.post(API.SEND_TEXT, data);
export const POST_DOCUMENT_FILE = (data) =>
  Axios.post(API.POST_DOCUMENT_FILE, data);
export const DELETE_USER_DOCUMENT = (data) =>
  Axios.delete(API.DELETE_USER_DOCUMENT + data);
export const UPDATE_DOCUMENT_FILE = (data) =>
  Axios.put(API.UPDATE_DOCUMENT_FILE, data);
export const GET_DOCUMENT_FILE = (data) =>
  Axios.post(API.GET_DOCUMENT_FILE + data.docId, { user_id: data.user_id });
export const ACCEPT_REJECT_DOCUMENT = (data) =>
  Axios.put(API.ACCEPT_REJECT_DOCUMENT, data);
export const RESET_USER_PASS = (data) => Axios.post(API.RESET_USER_PASS, data);
export const SMS_HISTORY = (data) => Axios.post(API.SMS_HISTORY, data);
export const ADD_EMAIL_DRAFT = (data) => Axios.post(API.ADD_EMAIL_DRAFT, data);
export const DRAFT_EMAIL_LIST = (data) =>
  Axios.post(API.DRAFT_EMAIL_LIST, data);
export const DRAFT_EMAIL_BY_ID = (data) =>
  Axios.get(API.DRAFT_EMAIL_BY_ID + data);

export const POST_CONFIGURE = (data) => Axios.put(API.POST_CONFIGURE, data);
export const GET_CONFIGURE = (data) => Axios.post(API.GET_CONFIGURE, data);
export const GET_FIELD_DATA = (data) => Axios.post(API.GET_FIELD_DATA, data);

export const ADD_NOTE = (data) => Axios.post(API.ADD_NOTE, data);
export const GET_NOTE_BY_ID = (data) => Axios.post(API.GET_NOTE_BY_ID, data);
export const UPDATE_NOTE = (data) => Axios.post(API.UPDATE_NOTE, data);
export const GET_SINGLE_NOTE = (data) => Axios.get(API.GET_SINGLE_NOTE + data);
export const DELETE_NOTE = (data) => Axios.delete(API.DELETE_NOTE + data);

export const SEND_DOCUMENTS_LIST = (data) =>
  Axios.get(API.SEND_DOCUMENTS_LIST + data);

// DELETE SOCIAL SUBSCRIBERS //

export const DELETE_FACEBOOK = (data) => Axios.post(API.DELETE_FACEBOOK, data);
export const DELETEALL_FACEBOOK = (data) =>
  Axios.delete(API.DELETEALL_FACEBOOK, data);
export const DELETE_INSTAGRAM = (data) =>
  Axios.post(API.DELETE_INSTAGRAM, data);
export const DELETEALL_INSTAGRAM = (data) =>
  Axios.delete(API.DELETEALL_INSTAGRAM, data);
export const DELETE_TWITTER = (data) => Axios.post(API.DELETE_TWITTER, data);
export const DELETEALL_TWITTER = (data) =>
  Axios.delete(API.DELETEALL_TWITTER, data);
export const DELETE_YOUTUBE = (data) => Axios.post(API.DELETE_YOUTUBE, data);
export const DELETEALL_YOUTUBE = (data) =>
  Axios.delete(API.DELETEALL_YOUTUBE, data);
export const DELETE_TIKTOK = (data) => Axios.post(API.DELETE_TIKTOK, data);
export const DELETEALL_TIKTOK = (data) =>
  Axios.delete(API.DELETEALL_TIKTOK, data);

export const DELETE_CONTACT = (data) => Axios.post(API.DELETE_CONTACT, data);
export const DELETEALL_CONTACT = (data) =>
  Axios.delete(API.DELETEALL_CONTACT, data);

export const DELETE_SUBSCRIBER = (data) =>
  Axios.post(API.DELETE_SUBSCRIBER, data);
export const DELETEALL_SUBSCRIBER = (data) =>
  Axios.delete(API.DELETEALL_SUBSCRIBER, data);

// ================ email signatures ================ //

export const ADD_SIGNATURE = (data) => Axios.post(API.ADD_SIGNATURE, data);
export const GET_SIGNATURE = () => Axios.get(API.GET_SIGNATURE);
export const UPDATE_SIGNATURE = (data) =>
  Axios.put(API.UPDATE_SIGNATURE + data?.id, data);
export const GET_SIGNATURE_BY_ID = (data) =>
  Axios.get(API.GET_SIGNATURE_BY_ID + data);
export const DELETE_SIGNATURE = (data) =>
  Axios.delete(API.DELETE_SIGNATURE + data);

export const GET_MESSAGE_BY_ID = (data) =>
  Axios.get(API.GET_MESSAGE_BY_ID + data);

export const GET_MESSAGE_LIST = (data) =>
  Axios.post(API.GET_MESSAGE_LIST, data);

export const GET_SUBSCRIBER_LIST = (data) =>
  Axios.post(API.GET_SUBSCRIBER_LIST, data);
export const GET_SUBSCRIBER_BY_ID = (data) =>
  Axios.get(API.GET_SUBSCRIBER_BY_ID + data);

export const GET_FACEBOOK_LIST = (data) =>
  Axios.post(API.GET_FACEBOOK_LIST, data);
export const GET_FACEBOOK_BY_ID = (data) =>
  Axios.get(API.GET_FACEBOOK_BY_ID + data);

export const GET_INSTAGRAM_LIST = (data) =>
  Axios.post(API.GET_INSTAGRAM_LIST, data);
export const GET_INSTAGRAM_BY_ID = (data) =>
  Axios.get(API.GET_INSTAGRAM_BY_ID + data);

export const GET_YOUTUBE_LIST = (data) =>
  Axios.post(API.GET_YOUTUBE_LIST, data);
export const GET_YOUTUBE_BY_ID = (data) =>
  Axios.get(API.GET_YOUTUBE_BY_ID + data);

export const GET_TWITTER_LIST = (data) =>
  Axios.post(API.GET_TWITTER_LIST, data);
export const GET_TWITTER_BY_ID = (data) =>
  Axios.get(API.GET_TWITTER_BY_ID + data);

export const GET_TIKTOK_LIST = (data) => Axios.post(API.GET_TIKTOK_LIST, data);
export const GET_TIKTOK_BY_ID = (data) =>
  Axios.get(API.GET_TIKTOK_BY_ID + data);

export const GET_FORM_LIST = (data) => Axios.post(API.GET_FORM_LIST, data);
export const GET_FORM_BY_ID = (data) => Axios.get(API.GET_FORM_BY_ID + data);

export const GET_FINANCE_LIST = (data) =>
  Axios.post(API.GET_FINANCE_LIST, data);
export const GET_FINANCE_BY_ID = (data) =>
  Axios.get(API.GET_FINANCE_BY_ID + data);

export const POST_FINANCIAL = (data) =>
  Axios.put(API.POST_FINANCIAL + data.userId, data.payload);

// =========== DETAIL SETTING ===========//

export const GET_DETAIL_SETTINGS = (data) => Axios.get(API.GET_DETAIL_SETTINGS);
export const UPDATE_DETAIL_SETTING = (data) =>
  Axios.put(API.UPDATE_DETAIL_SETTING, data);

export const GET_SUBADMIN_LIST = (data) =>
  Axios.post(API.GET_SUBADMIN_LIST, data);
export const POST_SUBADMIN = (data) => Axios.post(API.POST_SUBADMIN, data);
export const GET_SUBADMIN_BY_ID = (data) =>
  Axios.get(API.GET_SUBADMIN_BY_ID + data);
export const UPDATE_SUBADMIN = (data) =>
  Axios.put(API.UPDATE_SUBADMIN + data.userId, data);
export const DELETE_SUBADMIN = (data) =>
  Axios.delete(API.DELETE_SUBADMIN + data.userId);
export const RESET_SUBADMIN_PASS = (data) =>
  Axios.post(API.RESET_SUBADMIN_PASS, data);

export const DROPDOWN_SUBADMIN = (data) =>
  Axios.post(API.DROPDOWN_SUBADMIN, data);

// ====================== ROLE ===================== //

export const GET_ROLE_LIST = (data) => Axios.post(API.GET_ROLE_LIST, data);
export const POST_ROLE = (data) => Axios.post(API.POST_ROLE, data);
export const GET_ROLE_BY_ID = (data) => Axios.get(API.GET_ROLE_BY_ID + data);
export const UPDATE_ROLE = (data) =>
  Axios.put(API.UPDATE_ROLE + data.userId, data);
export const DELETE_ROLE = (data) =>
  Axios.delete(API.DELETE_ROLE + data.userId);

// // ================= MANAGE_CATEGORY =================== // //

export const CATEGORY_LIST = (data) => Axios.post(API.CATEGORY_LIST, data);
export const EDIT_MANAGE_CATEGORY = (data) =>
  Axios.get(API.EDIT_MANAGE_CATEGORY + data);
export const UPDATE_CATEGORY = (data) =>
  Axios.put(API.UPDATE_CATEGORY + data.userId, data);
export const ADD_CATEGORY = (data) => Axios.post(API.ADD_CATEGORY, data);
export const DELETE_CATEGORY = (data) =>
  Axios.delete(API.DELETE_CATEGORY + data.id);

// // ================= MANAGE_DOCUMENT_CATEGORY =================== // //

export const DOCUMENT_CATEGORY_LIST = (data) =>
  Axios.post(API.DOCUMENT_CATEGORY_LIST, data);
export const EDIT_MANAGE_DOCUMENT_CATEGORY = (data) =>
  Axios.get(API.EDIT_MANAGE_DOCUMENT_CATEGORY + data);
export const UPDATE_DOCUMENT_CATEGORY = (data) =>
  Axios.put(API.UPDATE_DOCUMENT_CATEGORY + data.userId, data);
export const ADD_DOCUMENT_CATEGORY = (data) =>
  Axios.post(API.ADD_DOCUMENT_CATEGORY, data);
export const DELETE_DOCUMENT_CATEGORY = (data) =>
  Axios.delete(API.DELETE_DOCUMENT_CATEGORY + data.id);

// // ================= MANAGE_EMAIL_TEMP =================== // //

export const EMAIL_TEMP_LIST = (data) => Axios.post(API.EMAIL_TEMP_LIST, data);
export const EMAIL_TEMP_ID = (data) => Axios.get(API.EMAIL_TEMP_ID + data);
export const UPDATE_EMAIL_TEMP = (data) =>
  Axios.put(API.UPDATE_EMAIL_TEMP + data.userId, data);
export const ADD_EMAIL_TEMP = (data) => Axios.post(API.ADD_EMAIL_TEMP, data);
export const DELETE_EMAIL_TEMP = (data) =>
  Axios.delete(API.DELETE_EMAIL_TEMP + data.userId);
export const EMAIL_TEMP_BY_TYPE = (data) =>
  Axios.post(API.EMAIL_TEMP_BY_TYPE, data);

// // ================= MANAGE_SMS_TEMP =================== // //

export const SMS_TEMP_LIST = (data) => Axios.post(API.SMS_TEMP_LIST, data);
export const SMS_TEMP_ID = (data) => Axios.get(API.SMS_TEMP_ID + data);
export const UPDATE_SMS_TEMP = (data) =>
  Axios.put(API.UPDATE_SMS_TEMP + data.userId, data);
export const ADD_SMS_TEMP = (data) => Axios.post(API.ADD_SMS_TEMP, data);
export const DELETE_SMS_TEMP = (data) =>
  Axios.delete(API.DELETE_SMS_TEMP + data.userId);
export const SMS_TEMP_BY_TYPE = (data) =>
  Axios.post(API.SMS_TEMP_BY_TYPE, data);

// // ================= MANAGE_DOCUMENTS =================== // //

export const DOCUMENTS_LIST = (data) => Axios.post(API.DOCUMENTS_LIST, data);
export const EDIT_MANAGE_DOCUMENTS = (data) =>
  Axios.get(API.EDIT_MANAGE_DOCUMENTS + data);
export const UPDATE_DOCUMENTS = (data) =>
  Axios.put(API.UPDATE_DOCUMENTS + data.userId, data);
export const ADD_DOCUMENTS = (data) => Axios.post(API.ADD_DOCUMENTS, data);
export const DELETE_DOCUMENTS = (data) =>
  Axios.delete(API.DELETE_DOCUMENTS + data.userId);
// export const EXPORT_DOCUMENTS = (data) =>
//   Axios.post(API.EXPORT_DOCUMENTS, data);

// // ================= MANAGE_TEMPLATES =================== // //

export const TEMPLATES_LIST = (data) => Axios.get(API.TEMPLATES_LIST);
export const EDIT_MANAGE_TEMPLATES = (data) =>
  Axios.get(API.EDIT_MANAGE_TEMPLATES + data);
export const UPDATE_TEMPLATES = (data) =>
  Axios.put(API.UPDATE_TEMPLATES + data.editId, data);
export const ADD_TEMPLATES = (data) => Axios.post(API.ADD_TEMPLATES, data);
export const DELETE_TEMPLATES = (data) =>
  Axios.delete(API.DELETE_TEMPLATES + data);

// // ================= FILE_UPLOAD =================== // //

export const FILE_UPLOAD = (data) => Axios.post(API.FILE_UPLOAD, data);

// ================= FAQ_LIST =================== //
export const FAQ_LIST = (data) => Axios.post(API.FAQ_LIST, data);
export const ADD_FAQ = (data) => Axios.post(API.ADD_FAQ, data);
export const EDIT_FAQ = (data) => Axios.post(API.EDIT_FAQ, data);
export const FAQ_DETAILS = (data) => Axios.get(API.FAQ_DETAILS + data);
export const DELETE_FAQ = (data) => Axios.post(API.DELETE_FAQ, data);
// ================= PROMO_CODES =================== //
export const PROMO_CODE_LIST = (data) => Axios.post(API.PROMO_CODE_LIST, data);
export const ADD_PROMO_CODE = (data) => Axios.post(API.ADD_PROMO_CODE, data);
export const EDIT_PROMO_CODES = (data) =>
  Axios.post(API.EDIT_PROMO_CODES, data);
export const PROMO_CODE_DETAILS = (data) =>
  Axios.get(API.PROMO_CODE_DETAILS + data);
export const DELETE_PROMO_CODE = (data) =>
  Axios.delete(API.DELETE_PROMO_CODE + data);

// ================= CONTENTPAGE_LIST =================== //
export const CONTENTPAGE_LIST = (data) =>
  Axios.post(API.CONTENTPAGE_LIST, data);
export const CONTENTPAGE_LIST_DETAILS = (data) =>
  Axios.get(API.CONTENTPAGE_LIST_DETAILS + data);
export const CONTENTPAGE_EDIT = (data) =>
  Axios.post(API.CONTENTPAGE_EDIT, data);

// =================== SYSTEM_ADMIN =================== //

export const CHANGE_PASS_OTP = (data) => Axios.post(API.CHANGE_PASS_OTP, data);
export const CHANGE_PASS_OTP_VERIFY = (data) =>
  Axios.post(API.CHANGE_PASS_OTP_VERIFY, data);
export const CHANGE_PASS_ADMIN = (data) =>
  Axios.post(API.CHANGE_PASS_ADMIN, data);

export const ADMIN_LIST = (data) => Axios.post(API.ADMIN_LIST, data);
export const ADD_ADMIN_LIST = (data) => Axios.post(API.ADD_ADMIN_LIST, data);
export const UPDATE_ADMIN_LIST = (data) =>
  Axios.post(API.UPDATE_ADMIN_LIST + data.userId, data);
export const CHANGE_ADMIN_PASSWORD = (data) =>
  Axios.post(API.CHANGE_ADMIN_PASSWORD, data);

//  ====================VEHICLE MAKE ==========================//
export const VEHICLE_MAKE_LIST = (data) =>
  Axios.post(API.VEHICLE_MAKE_LIST, data);
export const ADD_VEHICLE_MAKE = (data) =>
  Axios.post(API.ADD_VEHICLE_MAKE, data);
export const UPDATE_VEHICLE_MAKE = (data) =>
  Axios.post(API.UPDATE_VEHICLE_MAKE, data);
export const GET_VEHICLE_MAKE_DETAILS = (data) =>
  Axios.get(API.GET_VEHICLE_MAKE_DETAILS + data);
export const DELETE_VEHICLE_MAKE = (data) =>
  Axios.post(API.REMOVE_VEHICLE_MAKE, data);

//  ====================VEHICLE MODEL ==========================//
export const VEHICLE_MODEL_LIST = (data) =>
  Axios.post(API.VEHICLE_MODEL_LIST, data);
export const ADD_VEHICLE_MODEL = (data) =>
  Axios.post(API.ADD_VEHICLE_MODEL, data);
export const UPDATE_VEHICLE_MODEL = (data) =>
  Axios.post(API.UPDATE_VEHICLE_MODEL, data);
export const GET_VEHICLE_MODEL_DETAILS = (data) =>
  Axios.get(API.GET_VEHICLE_MODEL_DETAILS + data);
export const DELETE_VEHICLE_MODEL = (data) =>
  Axios.post(API.REMOVE_VEHICLE_MODEL, data);

//  ====================SERVICES ==========================//
// export const SERVICE_LIST = (data) => Axios.post(API.SERVICE_LIST, data);
export const ADD_SERVICE = (data) => Axios.post(API.ADD_SERVICE, data);
export const UPDATE_SERVICE = (data) => Axios.post(API.UPDATE_SERVICE, data);
export const GET_SERVICE_DETAILS = (data) =>
  Axios.get(API.GET_SERVICE_DETAILS + data);
export const DELETE_SERVICE = (data) => Axios.post(API.REMOVE_SERVICE, data);

//  ====================SERVICE ADDON ==========================//
export const SERVICE_ADDON_LIST = (data) =>
  Axios.post(API.SERVICE_ADDON_LIST, data);
export const ADD_SERVICE_ADDON = (data) =>
  Axios.post(API.ADD_SERVICE_ADDON, data);
export const UPDATE_SERVICE_ADDON = (data) =>
  Axios.post(API.UPDATE_SERVICE_ADDON, data);
export const GET_SERVICE_ADDON_DETAILS = (data) =>
  Axios.get(API.GET_SERVICE_ADDON_DETAILS + data);
export const DELETE_SERVICE_ADDON = (data) =>
  Axios.post(API.REMOVE_SERVICE_ADDON, data);

// ================= SETTINGS =================== //

export const BASIC_SETTING_DETAILS = (data) =>
  Axios.post(API.BASIC_SETTING_DETAILS, data);
export const GET_BASIC_DETAILS = (data) => Axios.get(API.GET_BASIC_DETAILS);

// ================= BOOKINGS =================== //

export const BOOKINGS_LIST = (data) => Axios.post(API.BOOKINGS_LIST, data);

export const BOOKING_DETAIL = (data) => Axios.get(API.BOOKING_DETAIL + data);

export const UPDATE_BOOKING_STATUS = (data) =>
  Axios.post(API.UPDATE_BOOKING_STATUS, data);

// ================= DISPUTES =================== //

export const DISPUTE_LIST = (data) => Axios.post(API.DISPUTE_LIST, data);

export const DISPUTE_DETAIL = (data) => Axios.get(API.DISPUTE_DETAIL + data);

export const UPDATE_DISPUTE_STATUS = (data) =>
  Axios.post(API.UPDATE_DISPUTE_STATUS, data);

export const REFUND_DISPUTE = (data) => Axios.post(API.REFUND_DISPUTE, data);

export const SEND_DISPUTE_REPLY = (data) =>
  Axios.post(API.SEND_DISPUTE_REPLY, data);

// ================= ADMIN TRANSACTION =================== //

export const ADMIN_TRANSACTION_LIST = (data) =>
  Axios.post(API.ADMIN_TRANSACTION_LIST, data);

export const EXPORT_ADMIN_TRANSACTION_LIST = (data) =>
  Axios.post(API.ADMIN_TRANSACTION_LIST, data);

// ================= PROVIDER WITHDRAWL =================== //

export const PROVIDER_WITHDRAWL_LIST = (data) =>
  Axios.post(API.PROVIDER_WITHDRAWL_LIST, data);

export const EXPORT_PROVIDER_WITHDRAWL_LIST = (data) =>
  Axios.post(API.PROVIDER_WITHDRAWL_LIST, data);

export const PROCESS_WITHDRAWAL = (data) =>
  Axios.post(API.PROCESS_WITHDRAWAL, data);

export const CANCEL_WITHDRAWAL = (data) =>
  Axios.post(API.CANCEL_WITHDRAWAL, data);

// ================= CUSTOMER REPORT GRAPH =================== //

export const CUSTOMER_REPORT_GRAPH = (data) =>
  Axios.post(API.CUSTOMER_REPORT_GRAPH, data);

// =================BOOKING REPORT GRAPH =================== //

export const BOOKING_REPORT_GRAPH = (data) =>
  Axios.post(API.BOOKING_REPORT_GRAPH, data);

// ================== SEND EMAIL/SMS SUBSCRIBER =============== //

export const SEND_EMAIL_SUBSCRIBER = (data) =>
  Axios.post(API.SEND_EMAIL_SUBSCRIBER, data);

export const SEND_SMS_SUBSCRIBER = (data) =>
  Axios.post(API.SEND_SMS_SUBSCRIBER, data);

export const HEALTH_INSURANCE_LIST = (data) =>
  Axios.post(API.HEALTH_INSURANCE_LIST, data);

export const GET_HEALTH_INSURANCE = (data) =>
  Axios.get(API.GET_HEALTH_INSURANCE + data);

export const CONVERT_TO_IRS = (data) => Axios.post(API.CONVERT_TO_IRS, data);
